import http from 'http/index';
import { cas3ApiRoute } from 'http/utility';

export const getCustomFields = ({ entity, entityField }) => http.get(
  cas3ApiRoute('/tenants-fields'),
  {
    params: { entity, entityField },
  },
).then((res) => res.data.tenantsFields);

export default {
  getCustomFields,
};
